import React from 'react';
import {Section, Header, Title, Image, Dash, EndImage} from '../styles/journey_section_styles';
import hotelIcon from '../images/hotel-icon40x40.png';
import restaurantIcon from '../images/restaurant-icon40x40.png';
import attractionIcon from '../images/attractions-icon-lrg.png';
import endIcon from '../images/end-icon.png'

const JourneySection = (props) => {

  var icon;
  var title;
  switch (props.business_type) {
    case "hotel":
      icon = hotelIcon;
      title = "Saved Hotels"
      break;
    case "restaurant":
      icon = restaurantIcon;
      title = "Saved Restaurants";
      break;
    case "attraction":
      icon = attractionIcon;
      title = "Saved Attractions";
      break;
    case "":
      icon = endIcon;
      title = "";
      break
    default:
      icon = endIcon;
      title = "error displaying favorites"
    }

    if(props.business_type === ""){
      return(
        <Section>
          <Header>
            <EndImage src={icon}/>
            <Title> {title} </Title>
          </Header>
        </Section>
      )
    }
    return(
      <Section>
        <Header>
          <Image src={icon}/>
          <Title> {title} </Title>
        </Header>
        <Dash/>
      </Section>
    )
}

export default JourneySection;
